/* MedSchoolBro — cart drawer helpers + bundle offers */
(function () {
  'use strict';

  var MODE_KEY = 'msb:drawer-mode';

  function drawerEl() { return document.getElementById('CartDrawer'); }

  function openDrawer(payload) {
    var drawer = drawerEl();
    if (!drawer || !drawer.hasAttribute('hidden')) return;
    try {
      document.dispatchEvent(new CustomEvent('product-ajax:added', { detail: { product: payload } }));
    } catch (e) {}
    setTimeout(function () {
      if (!drawer.hasAttribute('hidden')) return;
      var opener = document.querySelector(
        'header [aria-controls="CartDrawer"], [aria-controls="CartDrawer"]:not(.fixed-overlay):not(.drawer__close-btn), header a[href$="/cart"]'
      );
      if (opener) opener.click();
    }, 250);
  }

  /* Freshly rendered drawer content. Remembers which method works so later
     adds take the fast path straight away. */
  function fetchDrawer(sid) {
    function grab(doc) { return doc.querySelector('#CartDrawer .drawer__content'); }
    function viaSections(key, remap) {
      var url = window.location.pathname + '?sections=' + encodeURIComponent(key) + '&_=' + Date.now();
      return fetch(url, { headers: { Accept: 'application/json' }, cache: 'no-store' })
        .then(function (r) { return r.json(); })
        .then(function (json) {
          var html = json && json[key];
          if (!html) throw new Error('no section html for ' + key);
          if (remap) {
            html = html.replace(/-cart-drawer(?![_\w])/g, '-' + sid)
                       .replace(/data-section-id="cart-drawer"/g, 'data-section-id="' + sid + '"');
          }
          var el = grab(new DOMParser().parseFromString(html, 'text/html'));
          if (!el) throw new Error('drawer not in section html');
          return el;
        });
    }
    function viaPage() {
      var u = new URL(window.location.href);
      u.searchParams.set('_msb', Date.now());
      return fetch(u.toString(), { cache: 'no-store', credentials: 'same-origin' })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var el = grab(new DOMParser().parseFromString(html, 'text/html'));
          if (!el) throw new Error('drawer not in page html');
          return el;
        });
    }

    var methods = {
      id: function () { return viaSections(sid, false); },
      file: function () { return viaSections('cart-drawer', true); },
      page: viaPage
    };
    var order = ['id', 'file', 'page'];
    try {
      var saved = sessionStorage.getItem(MODE_KEY);
      if (saved && methods[saved]) order = [saved].concat(order.filter(function (m) { return m !== saved; }));
    } catch (e) {}

    return order.reduce(function (p, name) {
      return p.catch(function () {
        return methods[name]().then(function (el) {
          try { sessionStorage.setItem(MODE_KEY, name); } catch (e) {}
          return el;
        });
      });
    }, Promise.reject(new Error('start')));
  }

  function updateCounts() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var n = cart.item_count || 0;
        document.querySelectorAll('cart-count').forEach(function (el) {
          el.textContent = n < 100 ? n : '99+';
          if (n > 0) el.removeAttribute('hidden'); else el.setAttribute('hidden', '');
        });
        document.documentElement.classList.toggle('cart-has-items', n > 0);
      })
      .catch(function () {});
  }

  /* After a successful /cart/add.js: open the drawer immediately with a
     loading state, then swap in the fresh contents. */
  window.msbAfterAdd = function (payload) {
    var drawer = drawerEl();
    var sid = drawer && drawer.dataset.sectionId;
    if (!drawer || !sid) { window.location.href = '/cart'; return Promise.resolve(); }

    var content = drawer.querySelector('.drawer__content');
    if (content) content.classList.add('msb-loading');
    openDrawer(payload);

    return fetchDrawer(sid)
      .then(function (fresh) {
        var cur = drawer.querySelector('.drawer__content');
        if (!cur) throw new Error('live drawer content missing');
        cur.innerHTML = fresh.innerHTML;
        cur.classList.remove('msb-loading');
        return updateCounts();
      })
      .catch(function (err) {
        console.error('[msb] drawer refresh failed', err);
        window.location.href = '/cart';
      });
  };

  /* The theme's own remove / quantity updates re-render the items and
     footer but not the drawer header, so the free-shipping bar goes stale.
     Watch cart-changing requests and refresh the header after them. */
  var shipTimer = null;
  function refreshHeader() {
    var drawer = drawerEl();
    var sid = drawer && drawer.dataset.sectionId;
    if (!drawer || !sid) return;
    fetchDrawer(sid).then(function (fresh) {
      var next = fresh.querySelector('.cart-drawer__header');
      var cur = drawer.querySelector('.cart-drawer__header');
      if (next && cur) cur.innerHTML = next.innerHTML;
    }).catch(function () {});
  }
  if (window.fetch && !window.fetch.__msb) {
    var nativeFetch = window.fetch;
    var wrapped = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var p = nativeFetch.apply(this, arguments);
      if (/\/cart\/(change|update|add|clear)/.test(url)) {
        p.then(function () {
          clearTimeout(shipTimer);
          shipTimer = setTimeout(refreshHeader, 200);
        }, function () {});
      }
      return p;
    };
    wrapped.__msb = true;
    window.fetch = wrapped;
  }

  /* Checkout button feedback. Not disabled on click: a disabled submit
     button would drop name="checkout" from the form post. */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.msb-checkout');
    if (!btn || btn.classList.contains('is-busy')) return;
    var label = btn.querySelector('span');
    if (label) {
      btn.dataset.label = label.textContent;
      label.textContent = 'Checking out\u2026';
    }
    setTimeout(function () { btn.classList.add('is-busy'); }, 0);
  });
  /* back button from checkout (bfcache): restore the label */
  window.addEventListener('pageshow', function () {
    document.querySelectorAll('.msb-checkout.is-busy').forEach(function (btn) {
      btn.classList.remove('is-busy');
      var label = btn.querySelector('span');
      if (label && btn.dataset.label) label.textContent = btn.dataset.label;
    });
  });

  /* Flag the page while the cart drawer is open (used to hide the Klaviyo
     teaser and other floating widgets that would cover the drawer). */
  function watchDrawer() {
    var cd = drawerEl();
    if (!cd || !window.MutationObserver) return;
    var sync = function () {
      document.documentElement.classList.toggle('msb-cart-open', !cd.hasAttribute('hidden'));
    };
    new MutationObserver(sync).observe(cd, { attributes: true, attributeFilter: ['hidden', 'open', 'class'] });
    sync();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watchDrawer);
  else watchDrawer();

  /* Minus at quantity 1 removes the line instead of erroring. */
  document.addEventListener('click', function (e) {
    var minus = e.target.closest('#CartDrawer quantity-input button[name="minus"]');
    if (!minus) return;
    var input = minus.parentElement.querySelector('.quantity__input');
    if (!input || parseInt(input.value, 10) > 1) return;
    var item = minus.closest('.cart-item');
    var remove = item && item.querySelector('.cart-item__remove');
    if (!remove) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    remove.click();
  }, true);

  /* drawer bundle offers + empty-cart guides */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-msb-add]');
    if (!btn) return;
    e.preventDefault();
    if (btn.classList.contains('is-busy')) return;

    var ids = (btn.dataset.msbAdd || '')
      .split(',')
      .map(function (v) { return Number(v.trim()); })
      .filter(Boolean);
    if (!ids.length) return;

    var label = btn.textContent.trim();
    btn.classList.add('is-busy');
    btn.textContent = 'Adding\u2026';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: ids.map(function (id) { return { id: id, quantity: 1 }; }) })
    })
      .then(function (res) {
        if (!res.ok) return res.json().then(function (err) { throw err; });
        return res.json();
      })
      .then(function (payload) {
        btn.classList.remove('is-busy');
        btn.textContent = 'Added';
        window.msbAfterAdd(payload);
      })
      .catch(function () {
        btn.classList.remove('is-busy');
        btn.textContent = label;
      });
  });
})();
